import {FormErrorsFactory} from '../Errors/factory.js'
import {CaptchaFormValueObject} from './CaptchaFormValueObject.js'
import {ConfigFieldFormValueObject} from './ConfigFieldFormValueObject.js'
import {ConfigFormValueObject} from './ConfigFormValueObject.js'
import {DatalistFormValueObject} from './DatalistFormValueObject.js'
import {DatalistItemFormValueObject} from './DatalistItemFormValueObject.js'
import {DraftFormValueObject} from './DraftFormValueObject.js'
import {ModelDetailFormConfigValueObject} from './ModelDetailFormConfigValueObject.js'
import {SearchUrlFormValueObject} from './SearchUrlFormValueObject.js'
import {SpecsFormValueObject} from './SpecsFormValueObject.js'

export class FormValueObjectsFactory {
  /**
   * @method
   * @return {ConfigFieldFormValueObject}
   */
  static configFieldFormValueObject = ({
    constraints,
    context,
    datalist,
    disabled,
    display,
    help,
    hint,
    id,
    label,
    required,
    tabIndex,
    type
  }) => {
    ConfigFieldFormValueObject.validate({
      id,
      errorFactory: FormErrorsFactory.genericFormError
    })
    return new ConfigFieldFormValueObject({
      constraints,
      context,
      datalist,
      disabled,
      display,
      help,
      hint,
      id,
      label,
      required,
      tabIndex,
      type
    })
  }

  /**
   * @method
   * @return {ConfigFormValueObject}
   */
  static configFormValueObject = ({form, initialFieldValues = {}}) => {
    ConfigFormValueObject.validate({
      form,
      errorFactory: FormErrorsFactory.genericFormError
    })
    return new ConfigFormValueObject({form, initialFieldValues})
  }

  /**
   * @method
   * @param {Object} deps
   * @param {Boolean} deps.disabled
   * @param {Boolean} deps.hidden
   * @param {Array} deps.datalist
   * @return {SpecsFormValueObject}
   */
  static specsFormValueObject = ({disabled, hidden, datalist}) => new SpecsFormValueObject({disabled, hidden, datalist})

  /**
   * @method
   * @param {Object} draft
   * @return {DraftFormValueObject}
   */
  static draftFormValueObject = draft => new DraftFormValueObject(draft)

  static searchUrlFormValueObject = draft => new SearchUrlFormValueObject(draft)

  static modelDetailFormConfigValueObject = ({contractId, fields, showForm}) =>
    new ModelDetailFormConfigValueObject({contractId, fields, showForm})

  static captchaStatusFormValueObject = ({siteKey}) => new CaptchaFormValueObject({siteKey})

  static datalistFormValueObject = ({datalist}) => new DatalistFormValueObject({datalist})

  static datalistItemFormValueObject = ({text, value}) => new DatalistItemFormValueObject({text, value})
}
